import React from "react";
import {useDrag} from "react-dnd";

const MultiDnD = (props) => {
    const testCollection = props.testCollection ? props.testCollection : {};
    const tests = props.tests;

    const selectedTests = [];
    Object.entries(testCollection).forEach(entry => {
        const [key, value] = entry;
        if (value){
            selectedTests.push({id:key});
        }
    });

    const selectedTestCount = Object.keys(selectedTests).length;

    const id = 999999;
    const cellData = {id: id};
    let title = "test";
    let customerId = 0;
    let testType = "";

    if (tests && tests.length > 0) {
        testType = tests[0].treeviewtesttype;
        customerId = tests[0].customerId;
    }

    var childNodes = [];
    selectedTests.forEach(test => {
        var node = {
            title: test.id,
            key: test.id,
            testId: test.id,
            testData: {id: test.id, level1id:'00000000-0000-0000-0000-000000000000', level1key: null, level1value: null,
                                    level2id:'00000000-0000-0000-0000-000000000000', level2key: null, level2value: null,
                                    level3id:'00000000-0000-0000-0000-000000000000', level3key: null, level3value: null,
                                    level4id:'00000000-0000-0000-0000-000000000000', level4key: null, level4value: null,
                                    level5id:'00000000-0000-0000-0000-000000000000', level5key: null, level5value: null,
                                    level6id:'00000000-0000-0000-0000-000000000000', level6key: null, level6value: null
                                },
            type: "test",
            expanded: false,
            selected: false,
            children: []
        };

        childNodes.push(node);
    })

    const [{isDragging}, drag] = useDrag({
        type: "treeview-target",
        item: {
            name: "moveable-row-collection",
            listIndex: 0,
            getPrevRow: "getPrevRow() {}",
            lowerSiblingCounts: [0],
            swapFrom: null,
            swapLength: null,
            swapDepth: null,
            treeIndex: 99,
            scaffoldBlockPixelWidth: 28,
            node: {
                title: title,
                testId: id,
                testData: cellData,
                type: "tests",
                expanded: false,
                selected: true,
                customerId: customerId,
                testType: testType,
                children: childNodes
            },
            path: [1,2],
            treeid: "rst__2",
            rowDirection: "ltr",
            children: "<DragSource(NodeRendererDefault) />"
        },
        collect: (monitor) => ({
            isDragging: !!monitor.isDragging()
        })
    });

    return (
    <div ref={drag}>
        <span draggable={true} style={{cursor: isDragging ? "grabbing" : "grab"}} onDragEnd={() => {return false}} id={"drag1"}>
            <img style={{verticalAlign: "middle"}} src={'/images/drag.png'}/>({selectedTestCount})</span>
        </div>
    )
}

export default MultiDnD;
